export const ADMIN_CREATE_USER_VALIDATION_SCHEMA = {
  username: {
    required: 'Username is required',
    type: 'username',
  },
  email: {
    required: 'Email is required',
    type: 'email',
  },
  is_admin: {
    required: 'User Type is required',
  },
  is_active: {
    required: 'Status is required',
  },
  phone: {
    type: 'phone',
  },
};

export const ADMIN_EDIT_USER_VALIDATION_SCHEMA = {
  username: {
    required: 'Username is required',
    type: 'username',
  },
  email: {
    required: 'Email is required',
    type: 'email',
  },
  is_admin: {
    required: 'User Type is required',
  },
  is_active: {
    required: 'Status is required',
  },
  phone: {
    type: 'phone',
  },
};
